import BrandPromise from './BrandPromise/BrandPromise';
import DotCopyright from './DotCopyright';
import DotPrivacyTerms from './DotPrivacyTerms';
import styles from './Footer.module.scss';

export default function Footer() {
    return(
        <footer className={styles.footer} role="contentinfo">
            <BrandPromise />
            <span className={styles.information}>
                <DotPrivacyTerms />
                <DotCopyright />            
            </span>
        </footer>
    );
}